<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">In memory of the last generation who spared no</p>
<p style="text-align: center;">effort to give this generation the best start in life.</p><br/>
<p style="text-align: center;">For Rory, Henry, Esme, Lydia, Freya, Noah and Beatrix.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?c9334396